import type { ColumnDef } from '@tanstack/vue-table'
import { h } from 'vue'
import { PersonsOfInterest } from '../../tables/PersonsOfInterest'

const personsOfInterestColumns: ColumnDef<PersonsOfInterest.ListItem>[] = [
  {
    accessorKey: 'name',
    size: 200,
  },
  {
    accessorKey: 'titleList',
    header: 'Titler',
  },
  {
    accessorKey: 'signatureRequired',
  },
  {
    accessorKey: 'signedAt',
  },
  {
    id: 'actions',
    meta: {
      placement: 'end',
    },
    size: 20,
    cell: ({ row }) => {
      return h('div', '')
    },
  },
]

export default personsOfInterestColumns
